const mistakes = [
  {
    icon: "ri-calendar-close-line",
    title: "The Dormant Passport Trap",
    description:
      "You used your passport last November for a Cancun trip. It is now April, and you are booking a Rhine River cruise. Your passport expired in February while sitting in the drawer. This is the most common mistake we see from Estero snowbirds — the passport is fine when they arrive in the fall, expired by spring.",
    fix: "Check your expiration date every September before booking any winter or spring travel. Set a phone reminder for September 1st.",
  },
  {
    icon: "ri-parent-line",
    title: "The Child Passport Expiration Surprise",
    description:
      "Your daughter is now 11. Her passport was issued when she was 6 — which means it expired last year on her 11th birthday. You just booked her first trip to Canada to see the grandparents, and the airline requires a valid passport number to issue the ticket. Child passports are only valid for 5 years, and many parents forget this timeline.",
    fix: "Set a reminder for every child's passport expiration 6 months before it expires. Start renewal early for family travel.",
  },
  {
    icon: "ri-time-line",
    title: "The Six-Month Validity Oversight",
    description:
      "Your passport expires in August, and your Mediterranean cruise departs in May. You assume you are fine because it is still valid. But the Schengen Area, UK, and most Caribbean cruises require 3–6 months of validity beyond your return date. The airline denies boarding at RSW, and your non-refundable cruise cabin is lost.",
    fix: "Renew if your passport expires within 6–9 months of any international trip. Some countries require validity for the full duration of your stay.",
  },
  {
    icon: "ri-image-line",
    title: "The Wrong Photo",
    description:
      "You took a passport photo at a local pharmacy using a dark background, or you are smiling, or your glasses created a glare. The State Department rejects the photo, and your application is delayed by 2–3 weeks while you resubmit. This is entirely avoidable with proper guidance.",
    fix: "Follow State Department photo guidelines exactly: white/off-white background, neutral expression, no glasses, correct size (2×2 inches). We review your photo before submission.",
  },
  {
    icon: "ri-file-damage-line",
    title: "The Damaged Passport",
    description:
      "Your passport went through the washing machine, got water-damaged on a fishing trip to Estero Bay, or your dog chewed a corner. You think it is still usable because the data page is readable. Border control or the airline disagrees, and you are denied boarding at RSW.",
    fix: "Any physical damage, water damage, or unauthorized markings make a passport invalid. Replace it immediately through expedited service.",
  },
  {
    icon: "ri-draft-line",
    title: "The Form Error",
    description:
      "You filled out the DS-11 or DS-82 form online, printed it, and signed it. But you used blue ink instead of black, signed outside the box, or left a required field blank. The acceptance clerk catches it, or worse, the State Department rejects the application after weeks of processing.",
    fix: "Use black ink only, sign within the box boundaries, and double-check every field. We pre-review all forms before submission.",
  },
];

export default function EsteroMistakesSection() {
  return (
    <section className="py-16 md:py-20 bg-[#F8F9FB]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-[#B22222] text-xs font-bold uppercase tracking-[0.15em] mb-3">
            Avoid These Mistakes
          </span>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Common Passport Mistakes Estero Travelers Make
          </h2>
          <p className="text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            These are the errors we see most often from Southwest Florida travelers. Each one can cost you a trip, money, or weeks of stress.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {mistakes.map((m, i) => (
            <div
              key={i}
              className="bg-white rounded-lg p-6 border border-gray-100 hover:border-[#F6C344]/50 transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded-lg bg-[#B22222]/10 flex items-center justify-center shrink-0">
                  <i className={`${m.icon} text-[#B22222] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-serif text-base font-bold text-[#1A365D] mb-2">{m.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed mb-3">{m.description}</p>
                  <div className="bg-[#F8F9FB] rounded-md p-3">
                    <p className="text-emerald-700 text-xs font-semibold mb-0.5">
                      <i className="ri-check-line mr-1"></i>How to avoid it:
                    </p>
                    <p className="text-gray-600 text-xs leading-relaxed">{m.fix}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}